export const pickFirstExternalPricesBlock = <T>(
  externalPrices: Record<string, T> | T[] | null | undefined
): T | null => {
  if (!externalPrices || Array.isArray(externalPrices)) {
    return null;
  }

  return Object.values(externalPrices)[0] ?? null;
};
